<template>
  <v-container fluid>
    <v-container class="d-flex justify-space-between align-center" fluid>
      최종 갱신: {{ updatedAt.toLocaleString() }}
      <v-spacer></v-spacer>
      <v-btn icon @click="export2csv"><v-icon>mdi-download</v-icon></v-btn>
      <v-btn icon @click="fetchDevices"><v-icon>mdi-refresh</v-icon></v-btn>
    </v-container>

    <v-row>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="customFilters.group"
          :items="groups"
          label="노선"
          hide-details
          clearable
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="customFilters.plateNo"
          label="차량번호"
          hide-details
          clearable
          outlined></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        선택된 장치(총 {{selectedDevices.length}} 대)
        <v-btn color="success" @click="sendOn" :disabled="!selectedDevices.length">ON</v-btn>
        <v-btn color="error" @click="sendOff" :disabled="!selectedDevices.length">OFF</v-btn>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selectedDevices"
      show-select
      item-key="_id"
      :items="items"
      :loading="loading"
      :headers="headers"
      :search="search"
      :custom-filter="customFilter"
      class="text-no-wrap">
      <template v-slot:item.fueltype="{ item }">
        <fueltype-chip :fueltype="item.fueltype"></fueltype-chip>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item._id)"><v-icon>mdi-cog</v-icon></v-btn>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="({ 1: 'success', 0: 'gray' })[item.status]"
          label
        >{{ ({ 0: 'OFF', 1: 'ON'})[item.status] }}</v-chip>
      </template>
      <template v-slot:item.operating="{ item }">
        <v-chip
          v-if="item.operating > -1"
          :color="({ 1: 'success', 0: 'gray' })[item.operating]"
          label
        >{{ ({ 0: 'OFF', 1: 'ON'})[item.operating] }}</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getDeviceList, setISGMode } from '@/api'
import get from 'lodash/get'
import export2csv from '@/utils/export2csv'

export default {
  data () {
    return {
      selectedDevices: [],
      devices: [],
      customFilters: {
        plateNo: '',
        group: ''
      },
      headers: [
        {
          text: '노선',
          value: 'group.name'
        },
        {
          text: '차량번호',
          value: 'plateNo'
        },
        {
          text: '모뎀번호',
          value: 'modemNo'
        },
        {
          text: '상태',
          value: 'status'
        },
        {
          text: '진행중',
          value: 'operating'
        }
      ],
      loading: false,
      updatedAt: new Date()
    }
  },
  computed: {
    search () {
      return JSON.stringify(this.customFilters)
    },
    groups () {
      return Object.entries(this.items.reduce((groups, device) => {
        if (!groups[device.group._id]) groups[device.group._id] = device.group.name

        return groups
      }, {})).map(([_id, name]) => {
        return {
          text: name,
          value: _id
        }
      })
    },
    items () {
      return this.devices.map(device => {
        const group = {
          _id: get(device, 'group._id', null),
          name: get(device, 'group.name', '미지정')
        }
        const plateNo = get(device, 'info.plateNo', '미지정')
        const modemNo = device.mn
        const status = get(device, 'isInfo.isgMode', -1)
        const operating = get(device, 'setISG.isgMode', -1)
        return {
          _id: device._id,
          fueltype: device.fuelType,
          group,
          plateNo,
          modemNo,
          status,
          operating
        }
      })
    }
  },
  watch: {
    search () {
      this.selectedDevices = []
    }
  },
  created () {
    this.fetchDevices()
  },
  methods: {
    export2csv () {
      const options = {
        filename: '공회전 제한장치 관리',
        fields: [
          {
            label: '노선',
            value: 'group.name'
          },
          {
            label: '차량번호',
            value: 'plateNo'
          },
          {
            label: '모뎀번호',
            value: 'modemNo'
          },
          {
            label: '상태',
            value: (row, field) => row.status ? `켜짐` : `꺼짐`
          },
          {
            label: '진행중',
            value: (row, field) => {
              return ({
                '-1': '',
                '1': '켜는중',
                '0': '끄는중'
              })[row.operating]
            }
          }
        ]
      }

      const data = this.items

      export2csv(data, options)
    },
    async fetchDevices () {
      this.loading = true
      try {
        const query = {
          populate: 'group'
        }
        const { devices } = await getDeviceList(null, query)

        this.devices = devices
        this.updatedAt = new Date()
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    getEditPath (_id) {
      return `/settings/devices/edit/${_id}`
    },
    customFilter (value, search, item) {
      const { group = '', plateNo = '' } = JSON.parse(search)

      return value &&
      typeof value === 'string' &&
      (!group || item.group._id === group) &&
      (!plateNo || item.plateNo.indexOf(plateNo) !== -1)
    },
    send (status) {
      return setISGMode(this.selectedDevices, status)
    },
    async sendOn () {
      const message = `${this.selectedDevices.length} 대의 장치에 켜기 요청을 보내시겠습니까?`
      if (!confirm(message)) return
      await this.send(1)
      alert('성공적으로 요청을 보냈습니다.')
      this.fetchDevices()
    },
    async sendOff () {
      const message = `${this.selectedDevices.length} 대의 장치에 끄기 요청을 보내시겠습니까?`
      if (!confirm(message)) return
      await this.send(0)
      alert('성공적으로 요청을 보냈습니다.')
      this.fetchDevices()
    }
  }
}
</script>
